export default __webpack_public_path__ + "static/media/KnightHacks.9d8b2c7c.svg";